// @flow

import React from 'react'

export type PropTypes = {
  area: number,
  capacity: number,
}

export default (props: Object) => (
  <dl className="space-headnote sm-hide">
    <dt className="space-headnote__title">{i18n.t('page.room.areaTitle')}</dt>
    <dd className="space-headnote__item">
      {i18n.t('page.room.area', { area: props.area })}
    </dd>
    <dt className="space-headnote__title">
      {i18n.t('page.room.capacityTitle')}
    </dt>
    <dd className="space-headnote__item">
      {i18n.t('page.room.capacity', { capacity: props.capacity })}
    </dd>
  </dl>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailHeadnoteSection/index.jsx